import { Trans, useTranslation } from 'react-i18next';

export default function PaymentSummary({ amount }: { amount: number }) {
  const { t } = useTranslation('app');
  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 text-black">{t('topupSummary')}</p>
      <div className="flex justify-between">
        <p className="text-body_1 text-gray__dark_2">{t('theBalance')}</p>
        <p className="text-title_4 text-gray__dark_2">
          <Trans
            i18nKey="priceValue"
            t={t}
            values={{
              value: amount,
            }}
            components={{
              tag: <span>placeholder</span>,
            }}
          />
        </p>
      </div>
    </div>
  );
}
